<template>
  <PageWrapper
      :isLoading="isLoading"
      hasFilters
      @submitFilters="setPageNumberAndSendRequest"
  >
    <template #title> لیست کاربران {{ isVipUsersList ? "VIP" : "" }} </template>
    <template #titleBtn>
      <b-link to="/users/create" class="btn btn-success" v-if="!isVipUsersList">
        افزودن کاربر جدید
      </b-link>
      <BButton variant="success" v-else @click="renderAddVipToUserModal">
        افزودن پلن VIP به کاربر
      </BButton>
    </template>
    <template #filters>
      <SearchInput
          class="filters-width w-24"
          inputId="fullName"
          inputLabel="جستجو بر اساس نام کاربر"
          inputPlaceholder="علی..."
          v-model="usersListFilter.fullName"
          @enter="setPageNumberAndSendRequest"
      />
      <SearchInput
          class="filters-width w-24"
          inputId="mobile"
          inputLabel="جستجو بر اساس شماره کاربر"
          inputPlaceholder="0912..."
          v-model="usersListFilter.mobile"
          @enter="setPageNumberAndSendRequest"
      />
      <SearchInput
          class="filters-width w-24"
          inputId="email"
          inputLabel="جستجو بر اساس ایمیل کاربر"
          inputPlaceholder="info@ferman.org"
          v-model="usersListFilter.email"
          @enter="setPageNumberAndSendRequest"
      />
      <LanguagePicker
          v-if="!isVipUsersList"
          class="filters-width w-24"
          placeHolder="نمایش کاربرانی که برای این زبان رودمپ ندارند"
          @getLanguage="setRoadmapLanguageId"
      />
      <CustomDatePicker
          v-if="!isVipUsersList"
          class="filters-width w-24"
          inputId="createDate"
          @getSelectedDate="setCreateDate"
          inputLabel="تاریخ ایجاد"
          inputPlaceholder="1403/06/05"
      />
      <template v-if="isVipUsersList">
        <CustomSelect
            class="w-24 filters-width"
            inputId="isActiveVip"
            inputLabel="وضعیت اشتراک VIP"
            :customOptions="filterActiveStatuses"
            v-model="usersListFilter.isActiveVip"
        />
        <CustomSelect
            class="w-24 filters-width"
            inputId="hasMidnightReserve"
            inputLabel="وضعیت رزرو نیمه شب پلن کاربر"
            :customOptions="filterActiveStatuses"
            v-model="usersListFilter.hasMidnightReserve"
        />
        <CustomSelect
            class="w-24 filters-width"
            inputId="hasMasterReserve"
            inputLabel="وضعیت رزرو استاد پلن کاربر"
            :customOptions="filterActiveStatuses"
            v-model="usersListFilter.hasMasterReserve"
        />
        <CustomSelect
            class="w-24 filters-width"
            inputId="hasFridayReserve"
            inputLabel="وضعیت رزرو جمعه پلن کاربر"
            :customOptions="filterActiveStatuses"
            v-model="usersListFilter.hasFridayReserve"
        />
        <CustomDatePicker
            class="filters-width w-24"
            inputId="vipExpireTimeBigger"
            @getSelectedDate="setVipExpireTime"
            inputLabel="پلن های فعال تا تاریخ"
            inputPlaceholder="1403/06/05"
        />
      </template>
    </template>
    <CustomTable
        v-if="usersList"
        :pageNumber="usersListFilter.pageNumber"
        :count="usersListFilter.count"
        :totalCount="totalCount"
        :tableColumns="tableColumns"
        :tableItems="usersList"
        @changePage="changePage"
    >
      <template #type="data">
        {{ usersTypeEnum[data.item.type] }}
      </template>
      <template #email="data">
        {{ data.item.email || "-" }}
      </template>
      <template #mobile="data">
        <span
            class="mobile-ltr"
            :dir="ltr"
            style="direction: ltr !important;"
            :title="data.item.mobile || '-'"
        >
          {{ formatMobileForDisplay(data.item.mobile) }}
        </span>
      </template>
      <template #vipExpiredDate="data">
        <span style="white-space: nowrap !important">
          {{ new Date(data.item.createDate).toLocaleDateString("fa-IR") }} -
          {{ new Date(data.item.createDate).toLocaleTimeString("fa-IR", { hour: "2-digit", minute: "2-digit" }) }}
        </span>
      </template>
      <template #vipUser.title="data">
        <b-link :to="`/apps/vip/plans/${data.item.vipUserId}`" v-if="data.item.vipUser && data.item.vipUser.title">
          {{ data.item.vipUser.title }}
        </b-link>
      </template>
      <template #createDate="data">
        {{ new Date(data.item.createDate).toLocaleDateString("fa-IR") }}
      </template>
      <template #status="data">
        {{ data.item.status ? "فعال" : "غیر فعال" }}
      </template>
      <template #actions="data">
        <div class="d-flex align-items-center justify-content-between">
          <template v-if="!isVipUsersList">
            <b-link :to="`/users/${data.item.userId}`">
              <FeatherIcon class="text-primary" icon="EditIcon" size="20" />
            </b-link>
            <b-link
                v-if="data.item.hasRoadMapForThisLang === false"
                :to="`/students/roadmaps/create/${usersListFilter.roadMapLangId}/${data.item.userId}`"
            >
              <FeatherIcon class="text-info" icon="MapIcon" size="20" />
            </b-link>
          </template>
          <template v-else>
            <BButton size="sm" variant="transparent" @click="getVipPlanDeleteConfirmation(data.item)">
              <FeatherIcon class="text-danger" icon="Trash2Icon" size="20" />
            </BButton>
          </template>
        </div>
      </template>
    </CustomTable>
    <DeleteUserVipPlanConfirmationDialog @refetch="getAllUsers" :tempUserObject="tempUserObject" />
    <AddVipToUserModal @updateVipUsersList="getAllUsers" />
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import LanguagePicker from "@/views/components/Language/LanguagePicker.vue";
import { GetAllUsersList } from "@/libs/Api/Users";
import AddVipToUserModal from "@/views/components/VipUser/AddVipToUserModal.vue";
import DeleteUserVipPlanConfirmationDialog from "@/views/components/VipUser/DeleteUserVipPlanConfirmationDialog.vue";
import { BButton, BLink } from "bootstrap-vue";

export default {
  props: { isVipUsersList: { type: Boolean, default: false } },
  data() {
    return {
      isLoading: false,
      usersTypeEnum: {1:"مدیر کل",2:"مدیر زبان",3:"مدرس",4:"زبان آموز",5:"حسابدار",6:"پشتیبان",7:"بلاگر",8:"طراح سوال"},
      usersListFilter: { pageNumber:null,count:10,type:null,languageId:null,isVipAtLeastOne:null,isActiveVip:null,vipExpireTimeBigger:null,roadMapLangId:null,email:null,mobile:null,createDate:null,fullName:null,hasMidnightReserve:null,hasMasterReserve:null,hasFridayReserve:null },
      filterActiveStatuses:[{value:null,text:"همه"},{value:true,text:"فعال ها"},{value:false,text:"غیر‌فعال ها"}],
      usersList:null,
      totalCount:null,
      tempUserObject:null,
      tableColumns:[
        { key:"userId", label:"شناسه کاربر" },
        { key:"fullName", label:"نام کاربر" },
        { key:"mobile", label:"شماره همراه" },
        { key:"email", label:"ایمیل" },
        { key:"type", label:"نقش کاربر" },
        { key:"status", label:"وضعیت کاربر" },
        { key:"createDate", label:"تاریخ ثبت" },
        { key:"actions", label:"عملیات" },
      ]
    };
  },
  watch: {
    isVipUsersList: { handler() { this.setVipListFiltersOnChangeOfIsVipVariable(); this.getAllUsers(); } }
  },
  created() { this.setVipListFiltersOnChangeOfIsVipVariable(); },
  mounted() { this.getAllUsers(); },
  methods: {
    setCreateDate(d) { this.usersListFilter.createDate = d ? new Date(d).toISOString() : null; },
    setVipExpireTime(d) { this.usersListFilter.vipExpireTimeBigger = d ? new Date(d).toISOString() : null; },
    renderAddVipToUserModal() { this.$bvModal.show("add-vip-to-user"); },
    setVipListFiltersOnChangeOfIsVipVariable() {
      if(this.isVipUsersList){
        this.tableColumns.splice(6,1,{key:"vipExpiredDate",label:"تاریخ اتمام اشتراک VIP"},{key:"vipUser.title",label:"نام پلن"});
        this.usersListFilter.isVipAtLeastOne=true;
      } else {
        this.tableColumns.splice(6,2,{key:"actions",label:"عملیات"});
        this.usersListFilter.isVipAtLeastOne=null;
      }
      this.usersListFilter.pageNumber = this.computedPageRouteQuery||1;
    },
    getVipPlanDeleteConfirmation(u){ this.tempUserObject=JSON.parse(JSON.stringify(u)); this.$bvModal.show("vip-delete-confirmation-dialog"); },
    setPageNumberAndSendRequest(){ this.usersListFilter.pageNumber=1; this.setPageNumberQuery(1); this.getAllUsers(); },
    changePage(val){ this.usersListFilter.pageNumber=val; this.setPageNumberQuery(val); this.getAllUsers(); },
    setPageNumberQuery(pageNumber){ this.$router.replace({ path:this.$route.path, query:{ page:pageNumber } }); },
    setRoadmapLanguageId(langId){ this.usersListFilter.roadMapLangId=langId; },
    async getAllUsers() {
      try{
        this.isLoading=true;
        const req = new GetAllUsersList(this);
        req.setRequestParamDataObj(this.usersListFilter);
        await req.fetch(res => { if(res.isSuccess){ this.usersList=res.data.users; this.totalCount=res.data.usersCount; } }, e=>console.error(e));
      }finally{ this.isLoading=false; }
    },
    convertNumbers2English(str=""){ return String(str).replace(/[\u0660-\u0669\u06f0-\u06f9]/g,c=>String.fromCharCode(c.charCodeAt(0)&0xf)); },
    mobileDir(value){ if(!value)return "auto"; return /[0-9\u06F0-\u06F9\u0660-\u0669]/.test(String(value))?"ltr":"auto"; },
    formatMobileForDisplay(value){ if(!value)return "-"; return this.convertNumbers2English(String(value)); }
  },
  computed:{
    pageNumber(){ return this.usersListFilter.pageNumber; },
    computedPageRouteQuery(){ return this.$route.query?.page||null; }
  },
  components:{ PageWrapper, CustomTable, SearchInput, CustomDatePicker, CustomSelect, BButton, BLink, LanguagePicker, AddVipToUserModal, DeleteUserVipPlanConfirmationDialog }
};
</script>

<style scoped>
.mobile-ltr{direction:ltr;unicode-bidi:embed;display:inline-block;white-space:nowrap;}
</style>